export const lerExpiracaoDoToken = (token: string): number | null => {
  try {
    const partes = token.split('.')
    if (partes.length !== 3) return null

    const base64 = partes[1].replace(/-/g, '+').replace(/_/g, '/')
    const completo = base64.padEnd(Math.ceil(base64.length / 4) * 4, '=')
    const json = decodeURIComponent(
      atob(completo)
        .split('')
        .map((caractere) => '%' + caractere.charCodeAt(0).toString(16).padStart(2, '0'))
        .join(''),
    )
    const expiracao = Number(JSON.parse(json).exp)

    return Number.isFinite(expiracao) ? expiracao * 1000 : null
  } catch {
    return null
  }
}

export const tokenExpirado = (token: string, toleranciaMs = 0, agora = Date.now()): boolean => {
  const expiracao = lerExpiracaoDoToken(token)
  if (expiracao === null) return false

  return agora > expiracao + toleranciaMs
}
